// extracted by mini-css-extract-plugin
module.exports = {"title":"JDN8pcNtdQAn","tooltip":"_23GLoaswJ6WJ","tooltip_left":"_1oVJ87NpEyeb","tooltip_bottom":"_2mFrwLVqj7Of","popper":"_3nJZnXcNrdps"};